/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosResponse } from 'axios';
import { InfoNotification } from '../../../app.notification';
import { AxiosErrorResponse } from '../../../app.settings';

import api from '../../../axios';
import { IConcurso } from './model';

export async function getById(usuarioId: string): Promise<IConcurso | any> {
  try {
    const { data } = await api.get<AxiosResponse<IConcurso>>('/concurso/' + usuarioId);
    return data as unknown as IConcurso;
  } catch (error: any) {
    AxiosErrorResponse(error);
  }
}
export async function getAll(): Promise<IConcurso[] | undefined> {
  try {
    const { data } = await api.get<AxiosResponse<IConcurso[]>>('/concurso');
    return data as unknown as IConcurso[];
  } catch (error: any) {
    AxiosErrorResponse(error);
  }
}

export async function update(usuario: Partial<IConcurso>): Promise<IConcurso | any> {
  try {
    const { data } = await api.put<AxiosResponse<IConcurso>>('/concurso/' + usuario.id, {
      ...usuario,
    });
    return (data as unknown as IConcurso[])[0];
  } catch (error: any) {
    AxiosErrorResponse(error);
  }
}

export async function insert(usuario: IConcurso): Promise<IConcurso | any> {
  try {
    const { data } = await api.post<AxiosResponse<IConcurso>>('/concurso/', {
      ...usuario,
    });
    return (data as unknown as IConcurso[])[0];
  } catch (error: any) {
    AxiosErrorResponse(error);
  }
}

export async function save(usuario: IConcurso): Promise<IConcurso | any> {
  try {
    if (usuario.id) {
      return await update(usuario).then(() => {
        InfoNotification('Registro alterado!');
      });
    } else {
      return await insert(usuario).then(() => {
        InfoNotification('Registro criado!');
      });
    }
  } catch (error: any) {
    AxiosErrorResponse(error);
  }
}

export async function remove(usuarioId: string): Promise<IConcurso | any> {
  try {
    return await api.delete<AxiosResponse<IConcurso>>('/concurso/' + usuarioId).then(() => {
      InfoNotification('Registro excluido!');
    });
  } catch (error: any) {
    AxiosErrorResponse(error);
  }
}
